import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Renderer2, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from '../data.service';
import { urls } from '../urls';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { GoogleAnalyticsServiceService } from '../google-analytics-service.service';
import { log } from 'console';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.scss']
})
export class ProductViewComponent implements OnInit {
  private destroy$: Subject<void> = new Subject<void>(); // Subject to handle subscription cleanup
  private productData: any; // Variable to store the emitted data
  sortedCategoryHierarchy: any;
  breadCrumFlag: any;
  selectedCategory: any;
  categoryName: any;
  productCount: any;
  categoryList: any;
  public isFullListDisplayed: boolean = false;
  accodainResponse: any;
  accodainDescription: string;
  selectedCategoryCode: any;
  MatTabCategoryList: any;
  MatTabCategoryListFlag = false;
  slectedopenString: string
  brandFilterOptions: any = {}; // Variable to store brand filter options
  brandFilterControl: FormControl = new FormControl();
  otherFiltersControl: any = {}; // Object to store other filters' form controls
  selectedBrands = [];
  filter = {};
  viewHeaderTemplate = []
  viewEnabledFilter: boolean = false
  staticColumns: string[] = [];
  displayColumns = new Map
  displayedColumns: string[] = [];
  products = [];
  dynamicColumns: string[] = [];
  attributeColumns: { key: any; attributeName: string; }[];
  accordainFlag: any;
  filteredResults = [];
  selectedBrandFilters: string[] = [];
  selectedOtherFilters: { [key: string]: string[] } = {};

  selectedBrandOptions: any[] = []; // Array to store selected brand options
  selectedOtherFilterOptions: { [key: string]: any[] } = {}; // Object to store selected options for other filters
  brandOptions = []

  // Scroll pagination variables
  dataSource: MatTableDataSource<any>;
  dataLoaded = false;
  pageNumber = 0;
  pageSize = 20;
  loadingMoreData = false; // To prevent multiple API calls when scrolling
  request = {};
  //tableHeight: number = 480; // Set the initial table height
  //scrollBuffer: number = 100; // Set the buffer to trigger API call before reaching the bottom
  selectedCategoryTab: any;
  tabclickevent = false;
  requestProductView = {}
  dynamicFilters = false;
  filteredOptions: any = {};
  brandSearchInput: string;
  ngafterInbrand: boolean;
  showFullDescription: boolean = false;
  maxLinesToShow: number = 4;
  searchInput1 = ''
  defaultPanelHeight: number = 200; // Set the desired default height in pixels

  searchOpenString: string = '';
  countToStop: boolean = true;
  showCategoryName: any;
  totalProductCount: any;
  datashow: boolean = true;
  attributeFilterBuckets = [];
  shownData = [];
  sor: string = "";
  imageLink: string = "https://img.moglimg.com/p/I/P/7/d/MINIP7WQIU4X1-xxlarge.jpg";
  imgPrefix: string = urls.s3Link;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('tabGroup') tabGroup;
  @ViewChild('selectTrigger') selectTrigger: MatSelect;
  @ViewChild('toggleEl') toggleEl: any;
  @ViewChild('myInput') myInput: ElementRef;
  @ViewChildren('myInput2') myInput2!: QueryList<ElementRef>;
  isScrollable = true;
  scrollLeftVisible = true;
  scrollRightVisible = true;
  console = console;
  selectedIndex = 0
  activeTabIndex = 0; // Initialize with the index of the first tab
  shouldHighlightFirstTab = false;
  countryName: any;
  isToggled = false;
  isOpen = false;
  ToggleimageSource: string = '../assets/img/plusToggle.svg';
  supplierAvailable: boolean = false;
  searchCategoryID: any;
  brandIDs: any[];
  businessCode: string;

  @ViewChild('copyTooltip') copyTooltip!: MatTooltip;

  constructor(private analyticsService: GoogleAnalyticsServiceService, private dataService: DataService, private http: HttpClient, private renderer: Renderer2, private elementRef2: ElementRef, private paramRoute: ActivatedRoute, private router: Router, private snackBar: MatSnackBar) {
    // Subscribe to the emitted data from the data service

    this.dataService.searchFilterChange$.pipe(takeUntil(this.destroy$)).subscribe(async (data) => {
      // await this.getQueryParamsdata();
      if (data != null)
        this.dataService.eventTracker(this.sor ? this.sor : "CIS", "Product-Discovery", localStorage.getItem('request'), "/product-discovery");
      this.viewEnabledFilter = false
      this.supplierAvailable = false
      this.productData = data
      this.selectedBrandOptions = []
      this.selectedBrands = []
      this.initializeDatasets();
    });


  }
  async getQueryParamsdata() {

    this.paramRoute.queryParams.subscribe(params => {
      this.searchCategoryID = params['category'];
      this.searchOpenString = params['searchStr'] == undefined ? '' : params['searchStr'];
      if (params['brandIds'])
        this.brandIDs = Array.isArray(params['brandIds']) ? params['brandIds'] : [params['brandIds']];
      if (this.brandIDs) {
        this.selectedBrands = this.brandIDs;
        this.selectedBrandOptions = this.selectedBrands
        this.brandFilterControl.setValue(this.selectedBrandOptions);
      }

      this.sor = params['sor'];
    });

  }
  ngOnInit(): void {

    this.countryName = this.dataService.getSelectedCountryName().toLowerCase();
    this.businessCode = this.dataService.getSelectedParentBusinessCode();

    this.getQueryParamsdata();
    // this.paramRoute.queryParams.subscribe(params => {
    //        this.searchCategoryID = params['category'];
    //        this.searchOpenString = params['searchStr']==undefined?'':params['searchStr'];
    //       this.brandIDs = params['brandIds']?.split(',');
    //     });
    // this.requestProductView['childSearchRequired'] = false
    this.analyticsService.trackPageView('/product-discovery');
    if (localStorage.getItem('status') === "true") {
      localStorage.removeItem('status')
      window.location.reload();
      // if (localStorage.getItem('page1slectedbrandIds'))
      //   this.selectedBrands = localStorage.getItem('page1slectedbrandIds').split(',');
      // this.dataService.onSpinner()

      // this.paramRoute.queryParams.subscribe(params => {
      //   this.selectedCategory = params['category'].split('|')[0];
      //   // this.selectedCategory = params['category'];
      //   this.searchOpenString = params['searchStr'];
      //   // this.selectedBrands = params['brandIds']?.split(',');
      // });

      // this.loadData(this.selectedCategory, this.searchOpenString, this.selectedBrands)
      //this.dataService.offSpinner()
      // this.setDisplayedColumns()
    }

    this.pageNumber = 0;
    this.pageSize = 20;

    //  this.setDisplayedColumns()
    //this.dataSource = new MatTableDataSource(this.products);

    this.dataLoaded = true;
  }
  ngAfterViewInit(): void {
    // Call the method to load brand filter data
    this.selectedCategoryCode;

    this.tabclickevent = true;
    // this.getTabs()
    //this.onTabClick(this.selectedCategoryCode,this.showCategoryName,this.tabclickevent)
    this.loadBrandFilter();
    this.ngafterInbrand = true;
    this.checkScrollable();
  }
  async initializeDatasets() {
    this.countToStop = true
    try {
      //this.searchOpenString = localStorage.getItem('page1slectedopenString')
      // if (localStorage.getItem('page1slectedbrandIds')) {
      //   this.selectedBrands = localStorage.getItem('page1slectedbrandIds').split(',');
      //   this.selectedBrandOptions = this.selectedBrands

      // }

      if (this.brandIDs) {
        this.selectedBrands = this.brandIDs;
        this.selectedBrandOptions = this.selectedBrands

      }
      this.preSelectedBrands(this.selectedBrandOptions)
      this.dataService.onSpinner()
      this.products = this.productData?.data?.products;
      this.MatTabCategoryList = this.productData?.data?.searchedCategories;
      if (this.MatTabCategoryList) {
        this.selectedCategoryTab = this.MatTabCategoryList[0].categoryCode

        // localStorage.setItem('page1slectedCategory', this.selectedCategoryTab);
        this.showCategoryName = this.MatTabCategoryList[0].categoryName
      }


      //this.sortedCategoryHierarchy = this.breadCrumDataBy();

      // if (this.sortedCategoryHierarchy != null) {
      //   this.breadCrumFlag = true;
      // } else {
      //   this.breadCrumFlag = false;
      // }

      this.getTabs();
      // this.setDisplayedColumns();
      this.dataSource = new MatTableDataSource(this.products);
      this.updateSupplierDetailsInDataSource();

      //  await this.getQueryParamsdata();
      //  if (this.brandIDs) {
      //   this.selectedBrands = this.brandIDs;
      //   this.selectedBrandOptions = this.selectedBrands

      // }
      // this.preSelectedBrands(this.selectedBrandOptions)

      if (this.dataSource.data.length < 20)
        this.countToStop = false

      if (this.dataSource.data.length == 0)
        this.datashow = false
      this.dataService.offSpinner()
      this.breadCrumDataBy();
    } catch (error) {

      this.dataService.offSpinner()
      console.error('Error in initializing datasets:', error);
    }
  }

  updateSupplierDetailsInDataSource() {
    this.dataSource.data.forEach((element, index) => {
      if (element.supplierAvailable) {
        this.getSupplierDetails(element.moglixPartNumber, index);
      }
    });
    this.dataService.offSpinner();
  }

  getSupplierDetails(productId: any, index: any): any {
    this.dataService.onSpinner()
    let body = {
      "warehouseIds": []
    }
    let url = urls.supplierDetails + "?productId=" + productId + "&pageNo=0&pageSize=1&orderBy=desc";

    this.dataService.callRestful('POST', url, body, null, null, null).subscribe({
      next: response => {
        this.dataSource.filteredData[index]['txn_date'] = response?.data?.supplierDetails?.[0]?.lastTransactionDate;
        this.dataSource.filteredData[index]['tp'] = response?.data?.supplierDetails?.[0]?.lastTp
      },
      error: err => { },
      complete: () => { }
    });

  }



  preSelectedBrands(brands) {
    // Simulate some pre-selected brand codes (replace this with your actual logic)
    const preSelectedBrandCodes = brands;

    // Set the form control value to the pre-selected brand codes
    this.brandFilterControl.setValue(preSelectedBrandCodes);
  }

  breadCrumDataBy(): Promise<any> {
    if (this.productData?.data?.defaultCategory) {
      return new Promise<any>((resolve, reject) => {
        this.dataService.getBreadCrumData(this.selectedCategoryTab).subscribe(
          (data) => {
            const categoryIdHirarchy = data['categoryHierarchy'];
            this.sortedCategoryHierarchy = Object.keys(categoryIdHirarchy)
              .filter((key) => key.startsWith('category_name_level') && categoryIdHirarchy[key] !== null)
              .sort()
              .map((key) => ({ key: key, value: categoryIdHirarchy[key] }));

            // Get the value of 'category_name' and append it to the sortedCategoryHierarchy array
            const category_name = categoryIdHirarchy['category_name'];
            if (category_name) {
              this.sortedCategoryHierarchy.push({ key: 'category_name', value: category_name });
            }
            if (this.sortedCategoryHierarchy != null) {
              this.breadCrumFlag = true;
            } else {
              this.breadCrumFlag = false;
            }
            resolve(this.sortedCategoryHierarchy);
          },
          (error) => {
            // Handle error if necessary
            console.error(error);
            reject(error);
          }
        );
      });
    }
  }


  getTabs() {
    this.selectedIndex = 0
    this.tabclickevent = false;
    if (this.MatTabCategoryList != null) {
      // this.selectedCategoryTab = this.MatTabCategoryList[0].categoryCode

      this.activeTabIndex = 0;
      this.shouldHighlightFirstTab = true;
      // this.onTabClick(this.selectedCategoryTab, this.showCategoryName, this.tabclickevent)
      //filter load
      this.loadBrandFilter()
      //for displaying columns
      this.setDisplayedColumns()

      this.getAccordainData(this.selectedCategoryTab);
      // this.loadBrandFilter();

      this.MatTabCategoryListFlag = true;
      this.accordainFlag = true;
    }
  }
  getTabIndexToHighlight(): number {
    if (!this.MatTabCategoryList) return -1; // Return -1 if the data is not yet fetched

    // Find the index of the tab that matches the 'idToHighlight'
    const index = this.MatTabCategoryList.findIndex(item => item.id === this.MatTabCategoryList);
    return index;
  }
  async onTabClick(categoryCode, categoryName, tabclickevent: boolean) {

    this.tabclickevent = tabclickevent
    this.isFullListDisplayed = false
    this.dataService.onSpinner()
    if (this.tabclickevent) {
      this.showCategoryName = categoryName

      this.resetTabData()

      this.selectedCategoryTab = categoryCode;
      this.dataService.setSelectedCategoryCode(this.selectedCategoryTab)
      this.requestProductView['categoryCode'] = this.selectedCategoryTab
      // localStorage.setItem('page1slectedCategory', this.selectedCategoryTab);

      await this.tabClickProductView()

      const time: number = new Date().getTime()
      this.loadBrandFilter()

      console.log("time load", new Date().getTime() - time)
      const time2: number = new Date().getTime()
      this.setDisplayedColumns()
      console.log("time load2", new Date().getTime() - time2)

      this.dataSource = new MatTableDataSource(this.products);
      this.updateSupplierDetailsInDataSource();

      this.sortedCategoryHierarchy = this.breadCrumDataBy();

      this.getAccordainData(this.selectedCategoryTab);



      this.enableData()
      if (this.dataSource.data.length == 0) {
        this.dataService.showMessage('info', "No Product Found");
      }
    }
    // else {

    //   // await this.loadBrandFilter()
    //   // await this.setDisplayedColumns()
    //   this.dataSource = new MatTableDataSource(this.products);
    //   this.accordainFlag = true
    //   if (this.dataSource.data.length == 0) {
    //     this.dataService.showMessage('info', "No Product Found");
    //   }
    //   this.dataService.offSpinner()

    // }
  }


  async tabClickProductView() {
    this.pageNumber = 0
    this.pageSize = 20
    this.countToStop = true;
    //this.searchOpenString = localStorage.getItem('page1slectedopenString')
    if (this.brandIDs)
      this.selectedBrands = this.brandIDs;
    this.requestProductView['categoryCode'] = this.selectedCategoryTab
    this.requestProductView['brandIds'] = this.selectedBrands
    this.requestProductView['productSearchString'] = this.searchOpenString
    this.requestProductView['viewEnabledFilter'] = this.viewEnabledFilter
    this.requestProductView['supplierAvailable'] = this.supplierAvailable
    this.requestProductView['viewHeaderRequired'] = true
    this.requestProductView['viewFilterRequired'] = true
    this.requestProductView['countryName'] = this.countryName
    this.requestProductView['childSearchRequired'] = false
    this.requestProductView['businessCode'] = this.businessCode

    const time: number = new Date().getTime()
    return new Promise<any>((resolve, reject) => {
      const url = urls.search + `search/view/products?pageNo=${this.pageNumber}&pageSize=${this.pageSize}`;
      this.dataService.getProductViewAPI(url, this.requestProductView).subscribe(
        (data) => {
          this.productData = data
          this.products = this.productData?.data?.products
          resolve(this.productData);
          this.preSelectedBrands(this.selectedBrands)
        },
        (error) => {
          // Handle error if necessary
          console.error(error);
          reject(error);
        }
      );
      this.dataService.eventTracker(this.sor ? this.sor : "CIS", "Product-Discovery", JSON.stringify(this.requestProductView), "/product-discovery");
    });




  }
  async tabClickDynamicProductView() {

    this.pageNumber = 0
    this.pageSize = 20
    this.countToStop = true;
    if (localStorage.getItem('page1slectedbrandIds'))
      this.selectedBrands = localStorage.getItem('page1slectedbrandIds').split(',');
    this.requestProductView['categoryCode'] = this.selectedCategoryTab
    this.requestProductView['brandIds'] = this.selectedBrands
    this.requestProductView['productSearchString'] = this.searchOpenString//localStorage.getItem('page1slectedopenString')
    this.requestProductView['viewEnabledFilter'] = this.viewEnabledFilter
    this.requestProductView['supplierAvailable'] = this.supplierAvailable
    this.requestProductView['viewHeaderRequired'] = true
    this.requestProductView['viewFilterRequired'] = true
    this.requestProductView['countryName'] = this.countryName
    this.requestProductView['businessCode'] = this.businessCode

    return new Promise<any>((resolve, reject) => {
      const url = urls.search + `search/view/products?pageNo=${this.pageNumber}&pageSize=${this.pageSize}`;
      this.dataService.getProductViewAPI(url, this.requestProductView).subscribe(
        (data) => {
          this.productData = data

          this.products = this.productData?.data?.products
          resolve(this.productData);
        },
        (error) => {
          // Handle error if necessary
          console.error(error);
          reject(error);
        }
      );
      this.dataService.eventTracker(this.sor ? this.sor : "CIS", "Product-Discovery", JSON.stringify(this.requestProductView), "/product-discovery");
    });

  }
  getAccordainData(categoryID) {
    const apiAccordain =
      urls.platformdatprod +
      'cassandraFeed/category/getByCode?code=' +
      categoryID;

    this.accodainResponse = {};

    this.dataService.callRestful('GET', apiAccordain).subscribe(data => {
      this.dataService.offSpinner();

      this.accodainResponse = data['data'];
      this.accodainDescription = this.accodainResponse['categoryDesc'];

      this.getFormattedDescription();
    });
  }
  getFormattedDescription(): string {
    if (this.showFullDescription) {
      return this.accodainDescription;
    } else {
      let descriptionLines = []
      if (this.accodainDescription)
        descriptionLines = this.accodainDescription.split('\n');
      if (descriptionLines.length > this.maxLinesToShow) {
        return descriptionLines.slice(0, this.maxLinesToShow).join('\n');
      } else {
        return this.accodainDescription;
      }
    }
  }

  // Method to check if the "See More" button should be shown
  showSeeMoreButton(): boolean {
    const descriptionLines = this.accodainDescription.split('\n');
    return descriptionLines.length > this.maxLinesToShow;
  }

  // Method to toggle between full description and limited lines
  toggleDescription(): void {
    this.showFullDescription = !this.showFullDescription;
  }

  getBrandsFromApI() {
    const searchedBrands = this.productData?.data?.searchedBrands;
    if (searchedBrands != null) {
      this.brandOptions = Object.keys(searchedBrands).map((brandCode) => {

        const brand = searchedBrands[brandCode];
        return {
          brandCode,
          brandName: brand.brandName,
          brandId: brand.brandId,
          productCount: brand.productCount,
          documentAvailable: brand.documentAvailable,
          latestDocumentAvailable: brand.latestDocumentAvailable
        };
      });
    }
    const allBrandCodes = this.brandOptions.map(brand => brand.brandCode);

    // this.brandFilterOptions['Brand'] =  this.brandOptions;

    //this.selectedBrands = allBrandCodes

    return this.selectedBrands

  }
  loadBrandFilter() {

    // const viewFilterTemplate = this.productData?.data?.viewFilterTemplate;
    const attributeFilterBuckets = this.productData?.data?.attributeFilterBuckets;
    const searchedBrands = this.productData?.data?.searchedBrands;


    if (this.productData?.data?.viewFilterTemplate && this.productData?.data?.attributeFilterBuckets && this.productData?.data?.searchedBrands) {
      // Convert searchedBrands to the desired format
      const brandOptions = Object.keys(searchedBrands).map((brandCode) => {
        const brand = searchedBrands[brandCode];
        return {
          brandCode,
          brandName: brand.brandName,
          brandId: brand.brandId,
          productCount: brand.productCount,
          documentAvailable: brand.documentAvailable,
          latestDocumentAvailable: brand.latestDocumentAvailable
        };
      });


      // Create an object to store options for other filters
      const otherFilterOptions: any = {};
      Object.keys(attributeFilterBuckets).forEach((attributeName: string) => {
        if (attributeName !== 'Brand') {
          otherFilterOptions[attributeName] = attributeFilterBuckets[attributeName];
          this.filteredOptions[attributeName] = attributeFilterBuckets[attributeName];
        }
      });

      // Set brand filter options
      this.brandFilterOptions['Brand'] = brandOptions;

      // Set options for other filters without 'all' and 'clear'
      Object.keys(otherFilterOptions).forEach((attributeName: string) => {
        this.brandFilterOptions[attributeName] = otherFilterOptions[attributeName]
          .filter((option: any) => option !== 'all' && option !== 'clear');
      });


      this.productData?.data?.viewFilterTemplate.forEach((template) => {
        const attributeName = template.attributeName;

        if (this.productData?.data?.attributeFilterBuckets.hasOwnProperty(attributeName)) {
          // const attributeValues = attributeFilterBuckets[attributeName];
          if (attributeName !== 'Brand') {
            // Initialize form control for other filters
            this.otherFiltersControl[attributeName] = new FormControl();

            // Bind the valueChanges event to get selected options for other filters
            this.otherFiltersControl[attributeName].valueChanges.subscribe((value) => {
              this.onOtherFilterChange(attributeName, value);
            });
          }
          if (attributeName === 'Brand') {
            // Initialize form control for other filters
            this.brandFilterControl[attributeName] = new FormControl();

            // Bind the valueChanges event to get selected options for other filters
            this.brandFilterControl[attributeName].valueChanges.subscribe((value) => {
              this.onBrandFiltercatChange(attributeName);
            });
          }
        }
      });


    }
    this.dynamicFilters = true

  }

  getImage(link1, link2) {
    const imglink = link1 + link2;
  }


  clearBrandFilter() {
    this.brandFilterControl.setValue([]); // Clear the selected options for the brand filter

    this.applyFilters();
  }
  clearOtherFilter(attributeName: string) {
    this.otherFiltersControl[attributeName].setValue([]); // Clear the selected options for the specified filter
    this.onOtherFilterChange(attributeName, []); // Call the method to handle the change (Optional, if needed)
    this.applyDynamicFilters();
  }
  onBrandFiltercatChange(event: any) {
    // Handle changes in the brand filter selection
    this.selectedBrandOptions = this.brandFilterControl.value;
    this.selectedBrands = this.selectedBrandOptions
  }

  onOtherFilterChange(attributeName: string, event: any) {
    // Handle changes in other filter selections
    this.selectedOtherFilterOptions[attributeName] = this.otherFiltersControl[attributeName].value;
  }



  async applyFilters() {
    this.dataService.onSpinner()
    await this.requestDynamicFilters()

    this.dataLoaded = false
    // Access the selected options and perform actions as needed
    this.selectedBrands = this.selectedBrandOptions

    //this.selectedBrands = allBrandCodes 

    this.requestProductView['brandIds'] = this.selectedBrandOptions
    const attributeFilters = {
      "filterData": {

      }
    };

    this.requestProductView['attributeFilters'] = attributeFilters.filterData;

    Object.keys(this.selectedOtherFilterOptions).map((key) => {
      // Check if 'attributeFilters.filterData' exists, if not, create it
      if (!this.requestProductView['attributeFilters']['filterData']) {
        this.requestProductView['attributeFilters']['filterData'] = {};
      }


      if (this.selectedOtherFilterOptions[key].length !== 0 && this.selectedOtherFilterOptions[key] !== undefined) {
        this.requestProductView['attributeFilters']['filterData'][key] = this.selectedOtherFilterOptions[key];
      }
    });


    // Perform data filtering and update filteredResults array
    this.filteredResults = this.productData?.data?.products.filter((product: any) => {
      // Check if the product matches the selected brand filter options
      const brandFilterMatch = this.selectedBrandOptions.includes(product.brandCode);

      // Check if the product matches the selected options for other filters
      // const otherFiltersMatch = Object.keys(this.selectedOtherFilterOptions).every((attributeName: string) => {
      //   const selectedOptions = this.selectedOtherFilterOptions[attributeName];
      //   return selectedOptions.length === 0 || selectedOptions.includes(product[attributeName]);
      // });

      // Return true if the product matches all selected filter options
      // return brandFilterMatch && otherFiltersMatch;
    });
    this.requestProductView['categoryCode'] = this.selectedCategoryTab
    await this.tabClickDynamicProductView()
    await this.updateDynamicFiltersOption(this.brandFilterOptions)
    // await this.setDisplayedColumns()
    this.dataSource = new MatTableDataSource(this.products);
    this.updateSupplierDetailsInDataSource();
    this.dataService.offSpinner()
    this.dataLoaded = true

    this.selectTrigger.close();
  }

  // attribuesFilterLoad() {
  //   const otherFilterOptions: any = {};
  //   const attributeFilterBuckets = this.productData?.data?.attributeFilterBuckets;
  //   const viewFilterTemplate = this.productData?.data?.viewFilterTemplate;

  //   Object.keys(attributeFilterBuckets).forEach((attributeName: string) => {
  //     if (attributeName !== 'Brand') {
  //       otherFilterOptions[attributeName] = attributeFilterBuckets[attributeName];
  //       this.filteredOptions[attributeName][attributeName] = attributeFilterBuckets[attributeName];
  //     }
  //   });
  //   Object.keys(otherFilterOptions).forEach((attributeName: string) => {
  //     this.brandFilterOptions[attributeName] = otherFilterOptions[attributeName]
  //       .filter((option: any) => option !== 'all' && option !== 'clear');
  //   });
  //   viewFilterTemplate.forEach((template) => {
  //     const attributeName = template.attributeName;

  //     if (attributeFilterBuckets.hasOwnProperty(attributeName)) {
  //       const attributeValues = attributeFilterBuckets[attributeName];
  //       if (attributeName !== 'Brand') {
  //         // Initialize form control for other filters
  //         this.otherFiltersControl[attributeName] = new FormControl();

  //         // Bind the valueChanges event to get selected options for other filters
  //         this.otherFiltersControl[attributeName].valueChanges.subscribe((value) => {
  //           this.onOtherFilterChange(attributeName, value);
  //         });
  //       }

  //     }
  //   });
  // }



  async applyDynamicFilters() {

    this.dataService.onSpinner()
    await this.requestDynamicFilters()

    this.dataLoaded = false

    const attributeFilters = {
      "filterData": {

      }
    };

    // this.selectedBrands = this.selectedBrandOptions
    this.requestProductView['attributeFilters'] = attributeFilters.filterData;
    Object.keys(this.selectedOtherFilterOptions).map((key) => {
      // Check if 'attributeFilters.filterData' exists, if not, create it
      if (!this.requestProductView['attributeFilters']['filterData']) {
        this.requestProductView['attributeFilters']['filterData'] = {};
      }

      // Assign the value of the key to the corresponding property in the request object
      if (this.selectedOtherFilterOptions[key].length !== 0 && this.selectedOtherFilterOptions[key] !== undefined) {
        this.requestProductView['attributeFilters']['filterData'][key] = this.selectedOtherFilterOptions[key];
      }
    });



    await this.tabClickDynamicProductView()
    await this.updateDynamicFiltersOption(this.brandFilterOptions)
    // await this.setDisplayedColumns()
    this.dataSource = new MatTableDataSource(this.products);
    this.updateSupplierDetailsInDataSource();
    this.dataService.offSpinner()
    this.dataLoaded = true
  }
  async updateDynamicFiltersOption(bfp) {
    const attributeFilterBuckets = this.productData?.data?.attributeFilterBuckets;

    const brandFilterOptions = bfp; // Assuming this is where the brand filter options are stored

    // Get the keys of the attributeFilters.filterData object from the requestProductView payload
    let selectedFilterKeys = Object.keys(this.requestProductView['attributeFilters'].filterData || {});
    if (this.requestProductView['brandIds'] != undefined && this.requestProductView['brandIds']?.length != 0)
      selectedFilterKeys.push('Brand');
    // Update the brandFilterOptions for the keys that are not present in the selectedFilterKeys
    Object.keys(brandFilterOptions).forEach((key) => {
      if (!selectedFilterKeys.includes(key)) {
        if (key == 'Brand') {
          const searchedBrands = this.productData?.data?.searchedBrands
          // Convert searchedBrands to the desired format
          const brandOptions = Object.keys(searchedBrands).map((brandCode) => {
            const brand = searchedBrands[brandCode];
            return {
              brandCode,
              brandName: brand.brandName,
              brandId: brand.brandId,
              productCount: brand.productCount,
              documentAvailable: brand.documentAvailable,
              latestDocumentAvailable: brand.latestDocumentAvailable
            };
          });
          // Set brand filter options
          this.brandFilterOptions['Brand'] = brandOptions;
        } else {
          const optionsToAdd = attributeFilterBuckets[key];
          this.brandFilterOptions[key] = optionsToAdd;
          this.filteredOptions[key] = optionsToAdd
        }


      }
      else {
        const optionsToAdd = this.brandFilterOptions[key];
        this.brandFilterOptions[key] = optionsToAdd;
        this.filteredOptions[key] = optionsToAdd
        if (this.brandFilterOptions['Brand'] == undefined) {
          const viewFilterTemplate = this.productData?.data?.viewFilterTemplate;
          const searchedBrands = this.productData?.data?.searchedBrands;



          // Convert searchedBrands to the desired format
          const brandOptions = Object.keys(searchedBrands).map((brandCode) => {
            const brand = searchedBrands[brandCode];
            return {
              brandCode,
              brandName: brand.brandName,
              brandId: brand.brandId,
              productCount: brand.productCount,
              documentAvailable: brand.documentAvailable,
              latestDocumentAvailable: brand.latestDocumentAvailable
            };
          });
          // Set brand filter options
          this.brandFilterOptions['Brand'] = brandOptions;

        }
      }

    });
    // await this.loadBrandFilter();

    //await this.setDisplayedColumns()
    this.dataSource = new MatTableDataSource(this.products);
    this.updateSupplierDetailsInDataSource();
    this.dataService.offSpinner()
    this.dataLoaded = true
  }

  async clearAllFilters() {
    this.brandFilterControl.setValue([]);
    this.selectedBrandFilters = [];
    this.selectedBrands = []
    for (const filterKey in this.otherFiltersControl) {
      if (Object.prototype.hasOwnProperty.call(this.otherFiltersControl, filterKey)) {
        this.otherFiltersControl[filterKey].setValue([]);
        this.selectedOtherFilters[filterKey] = [];
      }
    }
    const attributeFilters = {
      "filterData": {

      }
    };
    this.requestProductView['attributeFilters'] = {};
    //this.requestProductView['categoryCode'] = localStorage.getItem('page1slectedCategory')
    if (this.brandIDs)
      this.selectedBrandOptions = this.brandIDs;//localStorage.getItem('page1slectedbrandIds').split(',');
    await this.tabClickDynamicProductView();
    await this.loadBrandFilter()
    //  await this.setDisplayedColumns();

    this.dataSource = new MatTableDataSource(this.products);
    this.updateSupplierDetailsInDataSource();
    this.dataService.offSpinner();
    this.dataLoaded = true;
  }




  // async loadData(selectedCategory, searchOpenString, selectedBrands) {

  //   try {
  //     this.loadingMoreData = true;

  //     if (searchOpenString != undefined)
  //       this.requestProductView['productSearchString'] = searchOpenString
  //     if (selectedCategory != undefined)
  //       this.requestProductView['categoryCode'] = selectedCategory
  //     if (selectedBrands != undefined) {
  //       this.requestProductView['brandIds'] = selectedBrands
  //       this.selectedBrandOptions = selectedBrands;
  //     }

  //     this.requestProductView['viewEnabledFilter'] = this.viewEnabledFilter
  //     this.requestProductView['supplierAvailable'] = this.supplierAvailable
  //     this.requestProductView['countryName'] = this.countryName
  //     const url = urls.search + `search/view/products?pageNo=${this.pageNumber}&pageSize=${this.pageSize}`;
  //     const newData = await this.dataService.getProductViewAPI(url, this.requestProductView).toPromise();
  //     if (newData.data.products.length != 0) {
  //       this.productData = newData
  //       this.initializeDatasets()
  //     } else {
  //       this.dataService.offSpinner()
  //       this.router.navigateByUrl('/no-result-found');

  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   } finally {
  //     this.loadingMoreData = false;
  //     this.dataLoaded = true;
  //   }
  // }

  setDisplayedColumns() {

    this.products = this.productData?.data?.products;


    if (this.products) {
      //  const uniqueColumnsSet = new Set<string>();
      // const combinedColumns = ['productName', 'moglixPartNumber', 'lp', 'lpDate'];

      // Include static columns with custom keys
      this.staticColumns = []
      this.staticColumns.push('Product ID/Name',
        'Brand Name',)




      // staticColumns.forEach((column) => {
      //   uniqueColumnsSet.add(column.attributeName);
      // });

      // staticColumnsAfter.forEach((column) => {
      //   uniqueColumnsSet.add(column.attributeName);
      // });


      // Include viewHeaderTemplate.attributeName columns not already present in static columns and combinedColumns
      this.productData?.data?.viewHeaderTemplate?.forEach((header: any) => {
        const key = header ? header?.idAttribute : '';
        const attributeName = header?.attributeName;

        if (!this.staticColumns.find(column => column === attributeName) && attributeName != null) {
          this.staticColumns.push(attributeName)
          this.displayColumns.set(key, attributeName);
        }
        // uniqueColumnsSet.add(attributeName);
        // if (
        //   !staticColumns.some((column) => column.attributeName === attributeName) &&
        //   !combinedColumns.includes(attributeName) && !staticColumnsAfter.some((column) => column.attributeName === attributeName)
        // ) {
        //   uniqueColumnsSet.add(attributeName);
        // }
      });

      // Convert uniqueColumnsSet to an array of objects with custom keys
      // const dynamicColumns = Array.from(uniqueColumnsSet)?.map((attributeName) => {
      //   const header = this.viewHeaderTemplate?.find((header) => header.attributeName === attributeName);
      //   const key = header ? header.idAttribute : ''; // Set default value if header is not found

      //   return { key: key, attributeName: attributeName };
      // });


      // Set the displayedColumns with the final unique headers and the combined columns
      //  let finalColumns = [...this.staticColumns, ...dynamicColumns, ...this.staticColumnsAfter];
      this.staticColumns.push(
        'itemsInPack/Uom',
        'MRP',
        'LP/LPDate',
        'tp/txn_date',
        'viewSupplier')
      // finalColumns = finalColumns.filter((column) => column.key !== "");


      //  this.displayedColumns = finalColumns.map((column) => column.attributeName);


      //this.attributeColumns = finalColumns;

      this.dataLoaded = true
    } else {
      this.dataLoaded = true;
    }
  }




  async resetTabData() {
    const keysToRetain = ['categoryCode', 'brandIds', 'productSearchString'];


    this.requestProductView = Object.keys(this.requestProductView).reduce((acc, key) => {
      if (keysToRetain.includes(key)) {
        // If the key is in the keysToRetain array, keep the existing value
        acc[key] = this.requestProductView[key];
      } else {
        // If the key is not in the keysToRetain array, set it to an empty array
        acc[key] = [];
      }
      return acc;
    }, {});
    const attributeFilters = {
      "filterData": {

      }
    };
    this.requestProductView['attributeFilters'] = attributeFilters.filterData;
    this.productData = {};
    this.selectedOtherFilterOptions = {};
    this.products = []
    this.selectedBrandOptions = []

    this.selectedBrands = []
    this.dataService.onSpinner()
    this.accordainFlag = false
    this.dynamicFilters = false
    this.dataLoaded = false
    this.brandFilterControl.setValue([]);

  }
  async enableData() {
    this.accordainFlag = true


    this.dynamicFilters = true

    this.dataLoaded = true
    this.dataService.offSpinner()
  }
  requestDynamicFilters() {

    this.dataService.onSpinner()

    this.productData = {}
    this.products = []
    this.dataLoaded = false
  }
  requestattributeFilters() {

    this.dataService.onSpinner()

    this.productData = {}
    this.products = []
    this.dataLoaded = false
  }
  async enableDynamicFilters() {


    this.dataLoaded = true
    this.dataService.offSpinner()
  }


  getCategoryListKeys(): string[] {
    return Object.keys(this.categoryList);
  }

  getHeaderBreadCrumData(categoryIdHirarchy) {

  }


  onCategoryFilterChange(categoryId: string) {
    this.requestProductView['categoryCode'] = categoryId
  }

  onBrandFilterChange(Brand: string) {
  }




  // Event handler for open filter change
  onOpenFilterChange(openFilterValue: string) {

  }
  onSearchFilterChange(searchFilterChange: string) {
  }
  oncontentSearchFilterChange(searchFilterChange: string) {
  }


  onScroll(category) {

    try {

      if (this.dataSource.data.length > 1 && this.countToStop) {
        this.loadingMoreData = true;
        this.pageNumber = this.pageNumber + 1

        this.requestProductView['categoryCode'] = this.selectedCategoryTab
        this.requestProductView['brandIds'] = this.selectedBrands
        this.requestProductView['productSearchString'] = this.searchOpenString
        this.requestProductView['viewEnabledFilter'] = this.viewEnabledFilter
        this.requestProductView['supplierAvailable'] = this.supplierAvailable
        this.requestProductView['viewHeaderRequired'] = false
        this.requestProductView['viewFilterRequired'] = false
        this.requestProductView['countryName'] = this.countryName
        this.requestProductView['businessCode'] = this.businessCode

        const url = urls.search + `search/view/products?pageNo=${this.pageNumber}&pageSize=${this.pageSize}`;
        this.dataService.eventTracker(this.sor ? this.sor : "CIS", "Product-Discovery", JSON.stringify(this.requestProductView), "/product-discovery");
        this.dataService.showMessage('success', "Data Loading...")
        this.dataService.callRestful('POST', url, this.requestProductView, null, null, null, false).subscribe(this.processLoginResult.bind(this));
      } else {
        this.isFullListDisplayed = true;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      this.loadingMoreData = false;
      this.dataLoaded = true;
    }
  }


  processLoginResult(data) {

    if (data.status && data.data.products) {
      let newData = data.data.length
      this.dataSource.data = [...this.dataSource.data, ...data.data.products];
      this.updateSupplierDetailsInDataSource();
      if (newData != undefined) {
        if (newData.length < 20)
          this.countToStop = false;
      }
    } else {
      this.dataService.showMessage('error', data.message);
    }

  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();


  }

  onWidthIncrease(): void {
    // Do something when the div's width increases
    this.checkScrollable();
    alert("hello")
    // You can call any other function or perform any action here
  }


  checkScrollable(): void {
    if (this.scrollContainer != undefined) {
      const container = this.scrollContainer.nativeElement;
      this.isScrollable = container.scrollWidth > container.clientWidth;
      this.updateScrollButtonVisibility(container.scrollLeft);
    }
  }

  updateScrollButtonVisibility(scrollLeft: number): void {
    const container = this.scrollContainer.nativeElement;
    this.scrollLeftVisible = scrollLeft > 0;
    this.scrollRightVisible = container.scrollWidth - container.clientWidth > scrollLeft;
  }

  scrollRight(): void {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = 150; // Adjust the scroll amount as per your requirements
    container.scrollLeft += scrollAmount;
    this.updateScrollButtonVisibility(container.scrollLeft);
  }

  scrollLeft(): void {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = 150; // Adjust the scroll amount as per your requirements
    container.scrollLeft -= scrollAmount;
    this.updateScrollButtonVisibility(container.scrollLeft);
  }
  checkOverflow(element) {
    return element.offsetHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth;
  }
  // onDivScroll(event: WheelEvent) {
  //   const scrollAmount = 30; // You can adjust this value to control the scroll speed

  //   if (event.deltaY > 0) {
  //     // Scroll right
  //     this.scrollContainer.nativeElement.scrollLeft += scrollAmount;
  //   } else {
  //     // Scroll left
  //     this.scrollContainer.nativeElement.scrollLeft -= scrollAmount;
  //   }

  //   event.preventDefault();
  // }
  // scrollTabs(event) {
  //   const children = this.tabGroup._tabHeader._elementRef.nativeElement.children;
  //   const back = children[0];
  //   const forward = children[2];
  //   if (event.deltaY > 0) {
  //     forward.click();
  //   } else {
  //     back.click();
  //   }
  // }



  productSupplier(id, supplierAvailable: boolean) {
    // this.router.navigateByUrl('/supplier-discovery?category=' + this.selectedCategoryTab + '&productId=' + id);

    //let searchCategoryID = null;
    //let brandIDs = null;
    //  let searchOpenString = null;
    // this.paramRoute.queryParams.subscribe(params => {
    //   searchCategoryID = params['category'];
    //   searchOpenString = params['searchStr'] == undefined ? '' : params['searchStr'];
    //   brandIDs = params['brandIds'];
    // });
    // this.console.log(supplierAvailable);
    // this.console.log(id);
    //localStorage.setItem('productSupplier',JSON.stringify(supplierAvailable));
    const queryParams: any = {};

    if (this.searchCategoryID) {
      queryParams.category = this.searchCategoryID;
    }
    if (this.brandIDs && this.brandIDs.length > 0) {
      queryParams.brandIds = this.brandIDs;
    }

    if (this.searchOpenString) {
      queryParams.searchStr = this.searchOpenString;
    }
    if (id) {
      queryParams.productId = id;
    }
    if (this.sor) {
      queryParams.sor = this.sor;
    }

    const url = this.router.createUrlTree(['/supplier-discovery'], { queryParams }).toString();
    window.open(url, '_blank');
  }


  productDetails(id, suplier) {
    localStorage.setItem("suplier", "false");
    if (suplier)
      localStorage.setItem("suplier", "true");
    // this.router.navigateByUrl('/product-detail?category=' + this.selectedCategoryTab + '&productId=' + id);
    window.open("/product-detail?category=" + this.selectedCategoryTab + "&productId=" + id);
  }

  toggleFunction(event: any) {

    if (this.viewEnabledFilter) {
      this.toggleEl.color = 'yellow'; // Replace 'your-custom-color' with your desired color
    }
    if (event.checked) {

      this.viewEnabledFilter = true

    } else {
      this.viewEnabledFilter = false;
    }


    this.requestProductView['categoryCode'] = this.selectedCategoryTab
    this.requestProductView['brandIds'] = this.selectedBrands
    this.requestProductView['productSearchString'] = this.searchOpenString
    this.requestProductView['viewEnabledFilter'] = this.viewEnabledFilter
    this.requestProductView['supplierAvailable'] = this.supplierAvailable
    this.requestProductView['viewHeaderRequired'] = true
    this.requestProductView['viewFilterRequired'] = true

    const attributeFilters = {
      "filterData": {

      }
    };

    this.requestProductView['attributeFilters'] = attributeFilters.filterData;

    Object.keys(this.selectedOtherFilterOptions).map((key) => {
      // Check if 'attributeFilters.filterData' exists, if not, create it
      if (!this.requestProductView['attributeFilters']['filterData']) {
        this.requestProductView['attributeFilters']['filterData'] = {};
      }


      if (this.selectedOtherFilterOptions[key].length !== 0 && this.selectedOtherFilterOptions[key] !== undefined) {
        this.requestProductView['attributeFilters']['filterData'][key] = this.selectedOtherFilterOptions[key];
      }
    });



    this.requestProductView['countryName'] = this.countryName
    this.requestProductView['businessCode'] = this.businessCode
    const url = urls.search + `search/view/products?pageNo=${this.pageNumber}&pageSize=${this.pageSize}`;
    this.dataService.eventTracker(this.sor ? this.sor : "CIS", "Product-Discovery", JSON.stringify(this.requestProductView), "/product-discovery");

    this.dataService.callRestful('POST', url, this.requestProductView, null, null, null, false).subscribe(this.processFilteredProductResult.bind(this));



  }
  toggleSupplierAvailable(event: any) {

    if (event.checked) {

      this.supplierAvailable = true

    } else {
      this.supplierAvailable = false;
    }


    this.requestProductView['categoryCode'] = this.selectedCategoryTab
    this.requestProductView['brandIds'] = this.selectedBrands
    this.requestProductView['productSearchString'] = this.searchOpenString
    this.requestProductView['viewEnabledFilter'] = this.viewEnabledFilter
    this.requestProductView['viewHeaderRequired'] = true
    this.requestProductView['viewFilterRequired'] = true
    this.requestProductView['supplierAvailable'] = this.supplierAvailable

    const attributeFilters = {
      "filterData": {

      }
    };

    this.requestProductView['attributeFilters'] = attributeFilters.filterData;

    Object.keys(this.selectedOtherFilterOptions).map((key) => {
      // Check if 'attributeFilters.filterData' exists, if not, create it
      if (!this.requestProductView['attributeFilters']['filterData']) {
        this.requestProductView['attributeFilters']['filterData'] = {};
      }

      if (this.selectedOtherFilterOptions[key].length !== 0 && this.selectedOtherFilterOptions[key] !== undefined) {
        this.requestProductView['attributeFilters']['filterData'][key] = this.selectedOtherFilterOptions[key];
      }
    });

    this.requestProductView['countryName'] = this.countryName
    this.requestProductView['businessCode'] = this.businessCode

    const url = urls.search + `search/view/products?pageNo=${this.pageNumber}&pageSize=${this.pageSize}`;
    this.dataService.eventTracker(this.sor ? this.sor : "CIS", "Product-Discovery", JSON.stringify(this.requestProductView), "/product-discovery");
    this.dataService.callRestful('POST', url, this.requestProductView, null, null, null, false).subscribe(this.processFilteredProductResult.bind(this));

  }

  processFilteredProductResult(data) {

    if (data.status && data.data.products) {

      this.productData = data

      this.products = this.productData?.data?.products

      this.updateDynamicFiltersOption(this.brandFilterOptions)
      // this.setDisplayedColumns()
      this.dataSource = new MatTableDataSource(this.products);
      // this.updateSupplierDetailsInDataSource();
      // this.dataService.offSpinner();
      if (this.dataSource.data.length == 0) {
        this.dataService.showMessage('info', "No Product Found");
      }
    } else {
      this.dataService.showMessage('error', data.message);
    }

  }


  filterOptions(attributeName: string) {

    if (!this.filteredOptions) return [];

    if (!this.searchInput1) return this.filteredOptions[attributeName] = this.brandFilterOptions[attributeName];

    if (this.filteredOptions[attributeName].length == 0) {
      this.filteredOptions[attributeName] = this.brandFilterOptions[attributeName]
    }


    // Assuming brandFilterOptions[template.attributeName] is an array of strings
    // this.filteredOptions[attributeName] = this.brandFilterOptions[attributeName].filter((option: string) => {
    //   return option.toLowerCase().includes(this.searchInput1.toLowerCase());
    // });

    this.filteredOptions[attributeName] = this.brandFilterOptions[attributeName].filter((option: string) => {
      // Regular expression to match any of the specified special characters
      const specialCharsRegex = /[-\/() ]/g;
      // Remove special characters from the option and search input
      const cleanedOption = option.replace(specialCharsRegex, '');
      const cleanedSearchInput = this.searchInput1.replace(specialCharsRegex, '');
      // Check if the cleaned option contains the cleaned search input
      return cleanedOption.toLowerCase().includes(cleanedSearchInput.toLowerCase());
    });



  }

  clearSearchInput(attributeName: string) {

    this.searchInput1 = '';
    this.filteredOptions[attributeName] = this.brandFilterOptions[attributeName];

  }

  handleSpaceKey(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.stopPropagation();
      // this.searchInput1 += ''; // Append a space character to the search input
    }
  }

  // getLastTxnDateandLastTP(productId : string) {
  //   let val :any = {}
  //   const url = 
  // }





  focusInputBrand() {
    setTimeout(() => {
      this.myInput.nativeElement.focus();
    }, 800)
  }
  focusInputAll(index: number) {
    setTimeout(() => {
      // const inputElements = this.myInput2;
      //   inputElements[index].nativeElement.focus();
      this.myInput2.toArray()[index].nativeElement.focus();
    }, 800)
  }
  attributeColumn(attributeName) {

    this.attributeColumns.find(attributeName).attributeName
  }
  toggleChange() {
    this.isToggled = !this.isToggled;
    console.log()
    this.ToggleimageSource = this.isToggled ? '../assets/img/minusToggle.svg' : '../assets/img/plusToggle.svg';

  }
  togglePanel() {
    this.isOpen = !this.isOpen;
  }
  getColor() {
    return 'red';
  }

  onVariantClick(categoryCode, brandId, cisGroupId, msn) {
    this.dataService.setSelectedCategoryCode(categoryCode[0]);
    this.dataService.setSelectedBrandId(brandId);
    this.dataService.setSelectedGroupId(cisGroupId);
    this.router.navigateByUrl('/product-varient?category=' + categoryCode[0]);

    // this.router.navigateByUrl('/product-varient');
  }
  copyToClipboard(text: string, tooltip: MatTooltip): void {
    navigator.clipboard.writeText(text).then(() => {
      const originalMessage = tooltip.message;
      tooltip.message = 'Copied!';
      tooltip.show();

      setTimeout(() => {
        tooltip.hide();
        tooltip.message = originalMessage;
      }, 500);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

}